(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Search icon with an empty query: focus the pill where it shows (desktop), otherwise open
     Dawn's predictive-search modal instead of submitting. */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-ol-search]');
    const input = form && form.querySelector('[name="q"]');
    if (!input || input.value.trim()) return;

    if (input.offsetWidth > 0) {
      event.preventDefault();
      input.focus();
      return;
    }

    const modal = form.closest('.ol-header').querySelector('details-modal');
    const summary = modal && modal.querySelector('summary');
    if (!summary || typeof modal.open !== 'function') return;

    event.preventDefault();
    modal.isOpen() ? modal.close() : modal.open({ target: summary });
  });

  /* Escape closes the pill's results dropdown (Dawn only handles Escape inside its modal). */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const search = event.target.closest && event.target.closest('.ol-hsearch');
    if (search && search.isOpen && typeof search.close === 'function') search.close();
  });

  } catch(e) { console.error(e); }
})();
})();
